  
export const isLeaveProcessed = (employee, loggedEmployeeId) => {
  const currentManager = employee?.approving_managers_status?.find(
    (manager) => manager.emp_id === loggedEmployeeId
  );

  if (currentManager) {
    return currentManager.status === "Approved" || 
           currentManager.status === "Rejected" || 
           currentManager.status === "Approved & Forwarded";
  }

  // Fall back to general HR/approval status
  const { is_hr_approved, is_approved } = employee;
  return is_hr_approved === 1 || 
         is_approved === 1 || 
         is_hr_approved === 0 || 
         is_approved === 0;
};


export const getStatusColor = (employee, loggedEmployeeId) => {
    const currentManager = employee?.approving_managers_status?.find(
      (manager) => manager.emp_id === loggedEmployeeId
    );

    if (currentManager) {
      switch (currentManager.status) {
        case "Approved":
          return "green";
        case "Rejected":
          return "red";
        case "Approved & Forwarded":
          return "gold";
        default:
          return "orange"; // Pending or unknown
      }
    }

    const { is_hr_approved, is_approved } = employee;

    if (is_hr_approved === 1 || is_approved === 1) {
      return "green";
    } else if (is_hr_approved === 0 || is_approved === 0) {
      return "red";
    } else if (is_hr_approved === 3 || is_approved === 3) {
      return "gold";
    } else {
      return "orange"; // Pending or unprocessed
    }
  };

  export const getStatusText = (employee, loggedEmployeeId) => {
    // console.log("Get Status Text Employee", employee);

    const currentManager = employee?.approving_managers_status?.find(
      (manager) => manager.emp_id === loggedEmployeeId
    );

    // console.log("Get Status Text Current Manager", currentManager);

    if (!currentManager) {
      const { is_hr_approved, is_approved } = employee;

      if (is_hr_approved === 1 || is_approved === 1) {
        return "Approved";
      } else if (is_hr_approved === 0 || is_approved === 0) {
        return "Declined";
      } else if (is_hr_approved === 3 || is_approved === 3) {
        return "Forwarded";
      } else {
        return "Pending";
      }
    }

    switch (currentManager.status) {
      case "Approved":
        return "Approved";
      case "Rejected":
        return "Rejected";
      case "Approved & Forwarded":
        return "Approved & Forwarded";
      default:
        return "Pending";
    }
};
  
export const truncateemployeeName = (userName) => {
    if (userName && userName.length > 15) {
      return userName.substring(0, 15) + "...";
    }
    return userName;
};
  


